import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const TeamPricing = ({ size = 61, style = {} }: PropsType) => {
  return (
    <svg
      width={size}
      height={(size / 61) * 60}
      style={style}
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_107_43001)">
        <rect
          width="60"
          height="60"
          transform="translate(0.5)"
          fill="#E2FAF3"
        />
        <path
          d="M49.3896 32.9165C55.5257 32.9169 60.5 37.8916 60.5 44.0278V47.0435C60.4998 48.2703 59.5052 49.2658 58.2783 49.2661C57.0512 49.2661 56.0559 48.2705 56.0557 47.0435V44.0278C56.0557 40.3462 53.0712 37.3613 49.3896 37.3608H49.1143C48.0218 35.3692 46.2716 33.7904 44.1553 32.9165H49.3896ZM43.8936 11.0913C49.2298 11.0917 53.5557 15.4181 53.5557 20.7544C53.5552 26.0903 49.2295 30.4161 43.8936 30.4165C42.7583 30.4165 41.6691 30.2185 40.6572 29.8589C41.5698 28.6629 42.2853 27.3093 42.7559 25.8452C43.1221 25.9267 43.5028 25.9722 43.8936 25.9722C46.7749 25.9718 49.1109 23.6357 49.1113 20.7544C49.1113 17.8727 46.7752 15.536 43.8936 15.5356C43.242 15.5356 42.6181 15.6553 42.043 15.8735C41.3723 14.5012 40.4754 13.2596 39.3984 12.1997C40.7413 11.4926 42.2705 11.0913 43.8936 11.0913Z"
          fill="#003125"
        />
        <path
          d="M15.8535 32.9165C13.7223 33.7965 11.9609 35.3904 10.8701 37.4019C7.53712 37.7707 4.94434 40.5966 4.94434 44.0278V47.0435C4.94409 48.2704 3.94959 49.2659 2.72266 49.2661C1.49557 49.266 0.500249 48.2705 0.5 47.0435V44.0278C0.5 37.8914 5.47491 32.9166 11.6113 32.9165H15.8535ZM17.1074 11.0913C18.4702 11.0914 19.7667 11.3742 20.9424 11.8833C19.7837 12.9484 18.8126 14.2148 18.0859 15.6274C17.769 15.5673 17.4419 15.5357 17.1074 15.5356C14.2255 15.5357 11.8887 17.8725 11.8887 20.7544C11.8891 23.6359 14.2258 25.9721 17.1074 25.9722C17.1688 25.9722 17.2301 25.9694 17.291 25.9673C17.7952 27.4857 18.5636 28.8834 19.542 30.106C18.7642 30.3079 17.9484 30.4165 17.1074 30.4165C11.7712 30.4164 7.4448 26.0905 7.44434 20.7544C7.44434 15.4179 11.7709 11.0914 17.1074 11.0913Z"
          fill="#003125"
        />
        <circle
          cx="30.0049"
          cy="21.7456"
          r="7.44044"
          fill="url(#paint0_linear_107_43001)"
          stroke="#003125"
          stroke-width="4"
        />
        <path
          d="M44.3889 48.0352V44.1305C44.3889 39.7122 40.8071 36.1305 36.3889 36.1305H23.6191C19.2009 36.1305 15.6191 39.7122 15.6191 44.1305V48.0352"
          stroke="#003125"
          stroke-width="4"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_107_43001"
          x1="29.4392"
          y1="25.752"
          x2="29.4392"
          y2="17.9109"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EF89E4" />
          <stop offset="0.965" stop-color="#BC5BEB" />
        </linearGradient>
        <clipPath id="clip0_107_43001">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TeamPricing;
